import { FC } from "react"
import { RateTableConfigDetails } from "../../../../../../../../types"
import { ConfigAdminPanel } from "../../../../../config-admin-panel"

interface Props {
  values: RateTableConfigDetails
  setDetailsField: (field: string, value: any) => void
}

const inputCls =
  "w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md text-gray-700 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"

const API_MODES = [
  "lender_price",
  "optimal_blue",
  "polly",
  "loan_sifter",
  "mortech",
  "mortgage_bot",
  "loanpass"
] as const

const RateTableAdvanced: FC<Props> = ({ values, setDetailsField }) => {
  const d = values.details

  return (
    <div className="space-y-6 pt-2">
      <ConfigAdminPanel className="p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-1">
          Advanced settings
        </h3>
        <p className="text-xs text-gray-400 mb-4">
          Low-level integration options
        </p>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              API mode
            </label>
            <select
              value={d.settings?.api_mode ?? ""}
              onChange={e =>
                setDetailsField("settings", {
                  ...d.settings,
                  api_mode: e.target.value || undefined
                })
              }
              className={inputCls}
            >
              <option value="">Choose an API mode</option>
              {API_MODES.map(mode => (
                <option key={mode} value={mode}>
                  {mode.replace(/_/g, " ").replace(/^\w/, c => c.toUpperCase())}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Prepaid interest days
            </label>
            <input
              type="number"
              min={0}
              value={d.settings?.prepaid_interest_days ?? ""}
              onChange={e =>
                setDetailsField("settings", {
                  ...d.settings,
                  prepaid_interest_days: e.target.value
                    ? Number(e.target.value)
                    : undefined
                })
              }
              className={inputCls}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Fee engine
            </label>
            <input
              type="text"
              value={d.settings?.api_config?.fee_engine ?? ""}
              onChange={e =>
                setDetailsField("settings", {
                  ...d.settings,
                  api_config: {
                    ...d.settings?.api_config,
                    fee_engine: e.target.value || undefined
                  }
                })
              }
              placeholder="e.g. lodestar"
              className={inputCls}
            />
          </div>
        </div>
      </ConfigAdminPanel>
    </div>
  )
}

export default RateTableAdvanced
